import { getFetcher } from "shared/api/api";
import client, { clientV2 } from "shared/api/axios";
import { createURL } from "shared/api/utils";

const SMART_GROUPS_BASE_URL = "smartGroups";

export interface GetSmartGroupRequest {
  id?: string;
  skipRequest?: boolean;
}

export interface SmartGroup {
  ID: string;
  name: string;
  description: string;
  eventType: string;
  createdAt: string;
  updatedAt: string;
  externalID?: string;
}

export const getSmartGroupRequestURI = ({
  id,
  skipRequest,
}: GetSmartGroupRequest): string =>
  skipRequest
    ? ""
    : client.getUri({
        method: "get",
        url: createURL([SMART_GROUPS_BASE_URL, id ?? ""]),
      });

export const getSmartGroup = (args: GetSmartGroupRequest) =>
  getFetcher<SmartGroup>(getSmartGroupRequestURI(args));

export const getSmartGroupV2RequestURI = ({
  id,
  skipRequest,
}: GetSmartGroupRequest): string =>
  skipRequest
    ? ""
    : clientV2.getUri({
        method: "get",
        url: createURL([SMART_GROUPS_BASE_URL, id ?? ""]),
      });

export const getSmartGroupV2 = (args: GetSmartGroupRequest) =>
  getFetcher<SmartGroup>(getSmartGroupV2RequestURI(args));

export interface ListSmartGroupsRequest {
  filter?: string;
  limit?: number;
  sort?: string;
}

const listSmartGroupsRequestURI = (params: ListSmartGroupsRequest): string =>
  client.getUri({
    method: "GET",
    url: SMART_GROUPS_BASE_URL,
    params,
  });

export const listSmartGroups = (args: ListSmartGroupsRequest) =>
  getFetcher<SmartGroup[]>(listSmartGroupsRequestURI(args));

const listSmartGroupsV2RequestURI = (params: ListSmartGroupsRequest): string =>
  clientV2.getUri({
    method: "GET",
    url: SMART_GROUPS_BASE_URL,
    params,
  });

export const listSmartGroupsV2 = (args: ListSmartGroupsRequest) =>
  getFetcher<SmartGroup[]>(listSmartGroupsV2RequestURI(args));
